import { useState } from 'react';
import { TextField, Button, Container, Box } from '@mui/material';
import useAlert from '../../hooks/useAlert';
import AlertModal from '../modals/AlertModal';
import useAuth from '../../hooks/useAuth';

interface LoginProps {
  defaultUsername?: string; // fill in username if we already know it
}

export default function Login({ defaultUsername = '' }: LoginProps) {
  const { login } = useAuth();
  const [username, setUsername] = useState(defaultUsername);
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { alertOpen, alertMessage, showAlert, closeAlert } = useAlert();

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    if (username.length <= 2 || password.length <= 2) {
      showAlert("Please enter a valid username and password");
      return;
    }

    setIsSubmitting(true);
    try {
      await login(username, password);
    } catch (error) {
      showAlert(`Login error: ${error}`);
    } finally {
      setIsSubmitting(false);
    }

  };

  return (
    <Container component="div" maxWidth="xs">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        mt={0}
      >
        <form onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="username"
            label="Username"
            name="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            Log in
          </Button>
        </form>
      </Box>
      <AlertModal open={alertOpen} onClose={closeAlert} message={alertMessage} />
    </Container>
  );
}
